import { render } from "./SignupComponent.vue?vue&type=template&id=3d984860"
import script from "./SignupComponent.vue?vue&type=script&lang=js"
export * from "./SignupComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/auth/SignupComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d984860"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d984860', __exports__)) {
    api.reload('3d984860', __exports__)
  }
  
  module.hot.accept("./SignupComponent.vue?vue&type=template&id=3d984860", () => {
    api.rerender('3d984860', render)
  })

}


export default __exports__